import { render, staticRenderFns } from "./otherAbilities.vue?vue&type=template&id=6cf7db2e&scoped=true&"
import script from "./otherAbilities.vue?vue&type=script&lang=js&"
export * from "./otherAbilities.vue?vue&type=script&lang=js&"
import style0 from "./otherAbilities.vue?vue&type=style&index=0&id=6cf7db2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf7db2e",
  null
  
)

export default component.exports